import React, { useEffect, useState } from "react";
import ProductList from "../components/ProductList";
import CategoryList from "../components/CategoryList";
import BestSellerProducts from "../components/BestSellerProducts";
import { Helmet } from 'react-helmet-async';
import { useNavigate,Link } from "react-router-dom";

const Homepage = () => {
  const [products, setProducts] = useState([]);
  const [activeAccordion, setActiveAccordion] = useState(null); // Track the active accordion
  const navigate = useNavigate();
  const heroImage = products.length > 0 ? products[0].picture : "";
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          "https://herokuapigate.etasick.workers.dev/api/products/"
        );
        const data = await response.json();
        setProducts(data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  // Function to toggle the accordion
  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <div className="homepage">
      
<Helmet>
                <title>Pro Prime Labs: Order magic mushroom spores,whey protein,research chemicals|Free shipping in USA</title>
                <meta name="description" content="Pro Prime Labs has a huge collection of the best magic mushroom spores, Whey Protein,Pure creatine,BCAA muscle catalyst and research chemicals."/>
            </Helmet>
      {/* Hero Section */}
      <section
        className="relative bg-cover bg-center h-[400px]"
        style={{
          backgroundImage: `url("${heroImage}")`,
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center text-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Buy Magic mushroom spores , whey protein,Pure creatine,testosterone boosters and research chemicals in USA.
            </h1>
            <p className="text-lg md:text-xl text-white">
              We offer you huge collection of  the best magic mushroom spores, testosterone boosters, research chemicals whey protein,pure creatine to help you relax, achieve your ultimate aesthetics and strength.
            </p>
            <button
              className="mt-6 bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700"
              onClick={() => navigate("/shop")}
            >
              Shop Now
            </button>
          </div>
        </div>
      </section>

      {/* Promotional Section */}
      <section className="py-16 bg-gray-100 text-center">
        <h2 className="text-3xl font-bold mb-6">What is our mission?</h2>
        <div className="flex flex-wrap justify-center space-x-6">
          <div className="w-full md:w-1/3 p-4 bg-white shadow rounded">
            <h3 className="text-xl font-semibold">Pro Prime Labs is here help your build strength,Relax,Research and be productive</h3>
            <p className="text-gray-600">
              Our collection of products is aligned to help you achive your biggest goals.
            </p>
          </div>
          <div className="w-full md:w-1/3 p-4 bg-white shadow rounded">
            <h3 className="text-xl font-semibold">Infinite Prime</h3>
            <p className="text-gray-600">
              Buy  Magic mushroom spores ,research chemicals and whey protein supplements in USA.
            </p>
          </div>
          <div className="w-full md:w-1/3 p-4 bg-white shadow rounded">
            <h3 className="text-xl font-semibold">Balance and stability</h3>
            <p className="text-gray-600">
              Our magic mushroom spores,testosterone boosters, whey protein,research chemicals are manufactured and sourced from trusted brands.
            </p>
          </div>
        </div>
      </section>
      <CategoryList/>
      <ProductList products={products}/>
      {/* FAQ Section */}
      <div className="container mx-auto px-4 py-8">
        <h2 className="text-3xl font-bold text-center mb-6">New to our Website? Checkout the FAQ below to get started.</h2>
        <div>
          {[
            {
              question: "If i am not presently in America can i still place an order?",
              answer:
                "Yes,you can place an order with your American address.We deliver to all 50 states.",
            },
            {
              question: "How long does delivery take?",
              answer:
                "We deliver with 72 hours.",
            },
            {
              question: "How do i place an order",
              answer:
                "Checkout the product you like click on it ,the system will take you to the product details page.Click add to cart .you an add up 100 products in single cart.",
            },
            {
              question: "Do you have a refund policy?",
              answer:
                "Yes,we have a 30-day money back refund policy.",
            },
          ].map((faq, index) => (
            <div
              key={index}
              className="border border-gray-300 rounded-md mb-4"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="flex justify-between w-full p-4 text-lg font-semibold focus:outline-none"
              >
                {faq.question}
                <span>{activeAccordion === index ? "-" : "+"}</span>
              </button>
              {activeAccordion === index && (
                <div className="p-4 text-gray-600">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default Homepage;
